import {
    NetworkError,
    generateRouteDefinition,
    makeCanonicalUrl,
    shouldRenderContextualMenu,
} from '@jet-app/music-classical/utilities';
import {
    makeArtistPageIntent,
    type ArtistPageIntent,
} from './ArtistPageIntent';
import type { IntentController } from '@jet/environment/dispatching';
import type { RouteProvider } from '@jet/environment/routing';
import type { ObjectGraph } from '@jet/environment/dependencies';
import type { ArtistPage } from '@jet-app/music-classical/models';
import { IntentKind } from '@jet-app/music-classical/intents';
import { renderArtistPage } from './renderArtistPage';
import { requestViewPage } from '@jet-app/music-classical/api/request-view-page';

// TODO: Confirm what URLs will look like
const canonicalUrlRule = {
    path: '/{storefront}/artist/{id}',
    query: [],
};

export const ArtistPageIntentController: IntentController<ArtistPageIntent> &
    RouteProvider = {
    $intentKind: IntentKind.ARTIST_PAGE,

    routes: generateRouteDefinition<ArtistPageIntent>(
        canonicalUrlRule,
        makeArtistPageIntent,
    ),

    async perform(
        intent: ArtistPageIntent,
        objectGraph: ObjectGraph,
    ): Promise<ArtistPage> {
        const canonicalURL = makeCanonicalUrl(
            canonicalUrlRule,
            intent,
            objectGraph,
        );

        const apiResponse = await requestViewPage(
            `artist/${intent.id}`,
            objectGraph,
        );

        if (!apiResponse?.body) {
            throw NetworkError.noContent();
        }

        const contextualMenuResponse = await shouldRenderContextualMenu(
            apiResponse.body.userComponentsAction?.url,
            objectGraph,
        );

        const page = renderArtistPage(
            canonicalURL,
            apiResponse,
            contextualMenuResponse,
            objectGraph,
        );

        return page;
    },
};
